import React from "react"
import Button from "components/common/Button"
import Panel from "components/panel"
import Text from "components/text"
import FormInput from "components/form/input"
import "./index.scss"

const EmailForm = ({ email, isVerified = false, resendEmail, errors }) => {
  return (
    <div className="email-settings">
      <Panel pad="40" grid>
        <Text text="Email Address" type="headline" />
        <FormInput
          horizontal
          label={"Email Address"}
          name={"email"}
          value={email}
          readOnly={true}
          success={isVerified}
          withIcon={true}
          labelFor={isVerified ? "This email is already verified." : ""}
        />
        {!isVerified && <hr />}
        {!isVerified && (
          <div className="action-container">
            <Button label="Resend Email" size="large" onClick={resendEmail} />
          </div>
        )}
      </Panel>
    </div>
  )
}

export default EmailForm
